import { render, staticRenderFns } from "./TBackButtonHeader.vue?vue&type=template&id=39db2a6c&scoped=true&"
import script from "./TBackButtonHeader.vue?vue&type=script&lang=ts&"
export * from "./TBackButtonHeader.vue?vue&type=script&lang=ts&"
import style0 from "./TBackButtonHeader.vue?vue&type=style&index=0&id=39db2a6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39db2a6c",
  null
  
)

export default component.exports